// client/src/pages/PopupSuccess.js
import { useEffect } from 'react';

const CLIENT_ORIGIN = process.env.REACT_APP_WEB_APP_URL || new URL(window.location.href).origin;

export default function PopupSuccess() {
    useEffect(() => {
        const params = new URLSearchParams(window.location.search);
        const onboarding = params.get('onboarding') === 'true';
        const targetUrl = onboarding ? `${CLIENT_ORIGIN}/?onboarding=true` : `${CLIENT_ORIGIN}/`;

        if (window.opener && !window.opener.closed) {
            window.opener.postMessage(
                { type: 'auth-success', onboarding },
                CLIENT_ORIGIN
            );
            // Small delay so opener can receive and process the message before popup closes
            const closeTimer = setTimeout(() => window.close(), 150);
            return () => clearTimeout(closeTimer);
        } else {
            // Fallback: opener lost (e.g. user closed it), navigate this window to home
            window.location.replace(targetUrl);
        }
    }, []);

    return null;
}
